import React from "react";
import "../css/cardPage.css";
import Plot from "react-plotly.js";

const cardData = [
  { id: 1, title: "Card 1", content: "This is the content for Card 1" },
  { id: 2, title: "Card 2", content: "This is the content for Card 2" },
  { id: 3, title: "Card 3", content: "This is the content for Card 3" },
];

function Contact() {
  return (
    <div className="card-page">
      {cardData.map((card) => (
        <div key={card.id} className="card">
          <h3>{card.title}</h3>
          <p>{card.content}</p>
          <Plot
            data={[
              {
                x: [1, 2, 3],
                y: [2, 6, 3],
                type: "scatter",
                mode: "lines+markers",
                marker: { color: "red" },
              },
              { type: "bar", x: [1, 2, 3], y: [2, 5, 3] },
            ]}
            layout={{
              width: 320,
              height: 240,
              title: { text: "A Fancy Plot" },
            }}
          />
        </div>
      ))}
    </div>
  );
}

export default Contact;
